import cx from 'classnames'
import { snakeCaseToTitleCase } from '~/utils/string'
import cs from './plate_status_text.scss'

function PlateStatusText({ status }: { status: string }) {
  return (
    <div
      className={cx(
        cs.plateStatus,
        status === 'checked_in' ? cs.checkedIn : cs.checkedOut,
      )}
    >
      {snakeCaseToTitleCase(status)}
    </div>
  )
}
export default PlateStatusText
